import React, { Fragment, useEffect, useState } from 'react';
import { Form, Card, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetDestinatarios, serviceActualizarDestinatario } from '../../../api/api-aprobacion-objecion';
import { FaPlusSquare, FaSyncAlt, FaEdit, FaTrashAlt } from "react-icons/fa";
import AddDestinatario from './add-destinatario';
import { Auth, LoadingComponent } from 'recupero-comunes'; 
import Mensajes from '../../mensajes'

const Destinatarios = ({ cfg_form, idCaso, idImplicado, idCiaImplicado, destinatarios, setDestinatarios, clasificaRespuesta, motivoRespuestaCIA, estadoSituacion, idAbogado}) => {

    const [loading, setLoading] = useState(false);
    const [destinatarioSelect, setDestinatarioSelect] = useState(null);
    //const [destinatarios, setDestinatarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [destinatarioTO, setDestinatarioTO] = useState(null);
    const [handleSubmit, setHandleSubmit] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [responseData, setResponseData] = useState({});

    useEffect(() => {//Efecto para carga inicial sin abogado
        if (idCiaImplicado && clasificaRespuesta && motivoRespuestaCIA) {
            getDestinatarios(null);
        }
    }, [idCiaImplicado, clasificaRespuesta, motivoRespuestaCIA])

    useEffect(() => {//Efecto para carga con abogado
        if (idCiaImplicado && clasificaRespuesta && motivoRespuestaCIA) {
            getDestinatarios(idAbogado);
        }
    }, [idCiaImplicado, clasificaRespuesta, motivoRespuestaCIA, idAbogado])

    useEffect(() => {//Efecto post agregar destinatario manual, sin abogado
        if (handleSubmit) {
            getDestinatarios(null);
        }
        setHandleSubmit(false);
    }, [handleSubmit])

    const getDestinatarios = async (abogado) => {        
        if (idCiaImplicado && clasificaRespuesta && motivoRespuestaCIA) {
            //setLoading(true);
            let query = Buffer.from(JSON.stringify({ idCaso: idCaso, concepto: 269, tipo: 2, idCiaImplicado: idCiaImplicado, idImplicado: idImplicado, clasificaRespuesta: clasificaRespuesta, motivoRespuesta:motivoRespuestaCIA, idAbogado:abogado })).toString('base64');
            const response = await serviceGetDestinatarios(query);

            setDestinatarios(response);
            //setLoading(false);
            validationClasificaDestino(response);
        }
    }

    const handleAddMod = (destinatario) => {
        if (estadoSituacion && estadoSituacion.envCorreoRpta) {
            setShowModal(true);
            setDestinatarioSelect(destinatario);
        }
    }

    const validationClasificaDestino = (data) => {
        let idDestinatario = null;
        data?.forEach(d => { if (d.codClasDestino == 270001) idDestinatario = d.id; })

        setDestinatarioTO(idDestinatario)
    }
    
    const handleEliminar = async (destinatario) => {
       
        setLoading(true);

        let dataResult = {};

        dataResult.idCaso = idCaso;
        dataResult.idImplicado = idImplicado;
        dataResult.idTipoNotificacion = 239010;
        dataResult.idSecuenciaNotifica = 1;
        dataResult.idUsuario = Auth.currentUser().rutUsuario;
        dataResult.secuenciaDestinatario = destinatario.idSecDestina;
        dataResult.accion=2;//Eliminar

        const response = await serviceActualizarDestinatario(dataResult);
        setLoading(false);
        setResponseData(response);
        setShowToast(true);
    }
    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { 
            getDestinatarios(null);
        }
    }
    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <div className='mt-2 mb-3'>
                <h6 style={{ fontWeiht: 'bold', color: 'color: rgb(255, 255, 255)'}}>
                    {cfg_form && cfg_form["aprobobjcartacobrotercero-subtitledestinatarios"]}
                </h6>
                <Card className='mt-1'>
                    <Table striped hover>
                        <thead style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            <tr>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["aprobobjcartacobrotercero-grilladest-tipo"]}</th>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["aprobobjcartacobrotercero-grilladest-destinatario"]}</th>
                                <th style={{ textAlign: 'center', fontSize: '14px' }}>{cfg_form && cfg_form["aprobobjcartacobrotercero-grilladest-clasdestino"]}</th>
                                <th style={{ fontSize: '14px' }}>{cfg_form && cfg_form["aprobobjcartacobrotercero-agregadest-email"]}</th>
                                <th style={{ textAlign: 'center', fontSize: '14px', width: '8%' }}>
                                    <FaSyncAlt
                                        size={20}
                                        color='white'
                                        title="Reload Destinatarios"
                                        style={{ marginRight: '8px', cursor: 'pointer' }}
                                        onClick={() => getDestinatarios(null)}
                                    />
                                    <FaPlusSquare
                                        size={20}
                                        color='white'
                                        title="Adicionar Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleAddMod(null)}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!idCiaImplicado
                                ? <tr><td colSpan={5} className='text-center text-muted fst-italic py-2'>Para obtener destinatarios es necesaria la Compañia Tercero</td></tr>
                                : destinatarios && destinatarios.map((pre, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{pre.tipoDestinatario}</td>
                                            <td>{pre.nombreDestinatario}</td>
                                            <td style={{ textAlign: 'center' }}>{pre.glosaClasDestino}</td>
                                            <td>{pre.emailDestinatario}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <FaEdit className='icon'
                                                    size={20}
                                                    color='gray'
                                                    title="Modificar Destinatario"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleAddMod(pre)}
                                                />
                                                <FaTrashAlt className='icon'
                                                    size={20}
                                                    color='gray'
                                                    title="Eliminar Destinatario"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleEliminar(pre)}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </Card>
            </div>
            {showToast && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={2000}
                    responseData={responseData}
                ></Mensajes>
            }
            <AddDestinatario
                cfg_form={cfg_form}
                showModal={showModal}
                setShowModal={setShowModal}
                destinatario={destinatarioSelect}
                destinatarioTO={destinatarioTO}
                setHandleSubmit={setHandleSubmit}
                idCaso={idCaso}
                idImplicado = {idImplicado}
            />
        </Fragment>
    )
}

export default Destinatarios;